import React from 'react';
import { useSelector } from 'react-redux';

import CustomerLinkCell from 'components/ReactTable/CellRenderers/CustomerLinkCell';
import AccountLinkCell from 'components/ReactTable/CellRenderers/AccountLinkCell';
import SelectFilter from 'components/ReactTable/Filters/SelectFilter';
import GetOptions from 'components/HomePage/GridColumnDefinitions/GetOptions';
import MultiSelectFilter from '../ReactTable/Filters/MultiSelectFilter';

const whsManagementMissingColumnDefs = openLinkedAccountModal => [
  {
    Header: 'Account',
    accessor: 'account',
    Cell: (cellInfo) => {
      const { row: { original } } = cellInfo;
      return (<AccountLinkCell dataKey="accountId" data={ original } permissions={ useSelector(state => state.auth.permissions) } />);
    },
    className: 'col-15p',
    sortIconId: 'sort-account',
    filterIconId: 'filter-icon-account',
    filterTextFieldId: 'filter-text-field-account'
  },
  {
    Header: 'Is Active ?',
    accessor: 'accountIsActive',
    Filter: SelectFilter,
    filterType: 'bool',
    options: GetOptions('isActive'),
    className: 'col-10p',
    sortIconId: 'sort-account-active',
    filterIconId: 'filter-icon-account-active',
  },
  {
    Header: 'Customer',
    accessor: 'customer',
    Cell: (cellInfo) => {
      const { row: { original } } = cellInfo;
      return (<CustomerLinkCell dataKey="customerDbId" data={ original } permissions={ useSelector(state => state.auth.permissions) } />);
    },
    className: 'col-15p',
    sortIconId: 'sort-customer',
    filterIconId: 'filter-icon-customer',
    filterTextFieldId: 'filter-text-field-customer'
  },
  {
    Header: 'Is Active ?',
    accessor: 'customerIsActive',
    Filter: SelectFilter,
    filterType: 'bool',
    options: GetOptions('isActive'),
    className: 'col-10p',
    sortIconId: 'sort-customer-active',
    filterIconId: 'filter-icon-customer-active',
  },
  {
    Header: 'Form Type',
    accessor: 'formType',
    Filter: MultiSelectFilter,
    id: 'imyFormType',
    className: 'col-10p',
    sortIconId: 'sort-customer-active',
    filterIconId: 'filter-icon-customer-active',
  },
  {
    Header: 'Workflow',
    accessor: 'workflowStage',
    Filter: MultiSelectFilter,
    id: 'workflowStageDescription',
    className: 'col-10p',
    sortIconId: 'sort-customer-active',
    filterIconId: 'filter-icon-customer-active',
  },
  {
    Header: 'Validity',
    accessor: 'formIsValid',
    Filter: SelectFilter,
    filterType: 'bool',
    options: GetOptions('formIsValid'),
    className: 'col-10p',
    sortIconId: 'sort-customer-active',
    filterIconId: 'filter-icon-customer-active',
  },
  {
    Header: 'Ch3 Status',
    accessor: 'chapter3Status',
    id: 'chapter3Status',
    Filter: MultiSelectFilter,
    className: 'col-10p',
    sortIconId: 'sort-customer-active',
    filterIconId: 'filter-icon-customer-active',
  },
  {
    Header: 'Expected WHS',
    accessor: 'expectedWithholdingStatementType',
    id: 'expectedWithholdingStatementType',
    Filter: MultiSelectFilter,
    className: 'col-10p',
    sortIconId: 'sort-customer-active',
    filterIconId: 'filter-icon-customer-active',
  },
];

export default whsManagementMissingColumnDefs;
